import { render, staticRenderFns } from "./UserSessions.vue?vue&type=template&id=dbce21ae&"
import script from "./UserSessions.vue?vue&type=script&lang=js&"
export * from "./UserSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports